import {
  BarChart3,
  Bell,
  Cloud,
  Coins,
  FileText,
  Gamepad2,
  History,
  LayoutDashboard,
  ListOrdered,
  MessageCircleQuestion,
  MapPin,
  Route,
  Settings,
  Smartphone,
  Sparkles,
  UserRound,
  type LucideIcon,
} from 'lucide-react';
import type { MessageKey } from '../../i18n/en';

export interface AppNavItem {
  to: string;
  labelKey: MessageKey;
  descriptionKey: MessageKey;
  icon: LucideIcon;
  end?: boolean;
  dot?: boolean;
}

export const APP_NAV: AppNavItem[] = [
  {
    to: '/app',
    labelKey: 'nav.dashboard',
    descriptionKey: 'nav.dashboard.desc',
    icon: LayoutDashboard,
    end: true,
  },
  {
    to: '/app/stationary',
    labelKey: 'nav.stationary',
    descriptionKey: 'nav.stationary.desc',
    icon: MapPin,
  },
  {
    to: '/app/playlist',
    labelKey: 'nav.playlist',
    descriptionKey: 'nav.playlist.desc',
    icon: ListOrdered,
  },
  {
    to: '/app/itinerary',
    labelKey: 'nav.itinerary',
    descriptionKey: 'nav.itinerary.desc',
    icon: Route,
  },
  {
    to: '/app/articles',
    labelKey: 'nav.articles',
    descriptionKey: 'nav.articles.desc',
    icon: FileText,
  },
  {
    to: '/app/joystick',
    labelKey: 'nav.joystick',
    descriptionKey: 'nav.joystick.desc',
    icon: Gamepad2,
  },
  {
    to: '/app/location-history',
    labelKey: 'nav.history',
    descriptionKey: 'nav.history.desc',
    icon: History,
  },
  {
    to: '/app/coin-usage',
    labelKey: 'nav.coins',
    descriptionKey: 'nav.coins.desc',
    icon: Coins,
  },
  {
    to: '/app/devices',
    labelKey: 'nav.devices',
    descriptionKey: 'nav.devices.desc',
    icon: Smartphone,
  },
  {
    to: '/app/drive-backup',
    labelKey: 'nav.backup',
    descriptionKey: 'nav.backup.desc',
    icon: Cloud,
  },
  {
    to: '/app/analytics',
    labelKey: 'nav.analytics',
    descriptionKey: 'nav.analytics.desc',
    icon: BarChart3,
  },
  {
    to: '/app/whats-new',
    labelKey: 'nav.whatsNew',
    descriptionKey: 'nav.whatsNew.desc',
    icon: Sparkles,
    dot: true,
  },
  {
    to: '/app/notifications',
    labelKey: 'nav.notifications',
    descriptionKey: 'nav.notifications.desc',
    icon: Bell,
  },
  {
    to: '/app/account',
    labelKey: 'nav.account',
    descriptionKey: 'nav.account.desc',
    icon: UserRound,
  },
  {
    to: '/app/queries',
    labelKey: 'nav.help',
    descriptionKey: 'nav.help.desc',
    icon: MessageCircleQuestion,
  },
  {
    to: '/app/settings',
    labelKey: 'nav.settings',
    descriptionKey: 'nav.settings.desc',
    icon: Settings,
  },
];
